import { all } from 'redux-saga/effects';

import onsiteBookingPatientSaga from './onsite-booking-patient-saga';
import onsiteBookingSaga from './onsite-booking-saga';

export default function* rootSaga() {
  yield all([onsiteBookingSaga(), onsiteBookingPatientSaga()]);
}
